<template>
  <div class="label">
    <div
      v-for="(item,index) in list"
      :key="index"
      v-on:mouseover="showToggle(index)"
      v-on:mouseout="handleHide"
      @click="toMarket(item.path)"
      :class="['sort','mouse',NavBar == 1 ? 'NarBarUlColor1' : 'NarBarUlColor2']"
    >
      <div
        class="title"
        :class="[index === isShow?'active':'',item.path == path?'active':'']"
      >{{item.title}}</div>
      <!-- index === isShow -->
      <div v-show="index === isShow">
        <div v-for="(item1,idx) in item.list" :key="idx" class="hoverShow">
          <div v-on:click="handleHide" @click="toMarket(item1.path)">{{item1.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["NavBar"],
  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.goBack, false);
    }
    this.path = this.$route.path;
  },
  data() {
    return {
      list: [
        { 
          title: "首页",
          path: "/"
        },
        {
          title: "数据服务",
          path: "/datahub"
        },
        {
          title: "应用市场",
          //   path: "/appMaket"
          path: "/appMaket",
       
        },
        {
          title: "SDGs知识库",
          path: "",
          list: [
            {
              title: "SDGs指标知识库",
              path: "/sdgsindicators"
            },
            {
              title: "SDGs报告",
              path: "/sdgsreports"
            }
            // ,
            // {
            //   title: "应用市场",
            //   path: "/appMaket2"
            // }
          ]
        }
      ],
      isShow: -1,
      path: null
    };
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      this.path = this.$route.path;

    },
    toMarket(path,parentpath) {
    
      if (path != "") {
        this.$router.push(path);
      }
      if(parentpath){
            this.path = parentpath;
      }else{
            this.path = path;
      }
    
    },
    showToggle(index) {
      this.isShow = index;
    },
    handleHide() {
      this.isShow = !this.isShow;
    },
    dianji(e) {
    }
  },
  created() {}
};
</script>
  <style scoped lang="scss">
.label {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.active {
  //   color: #000;
  /* background-color: rgba(0, 0, 0, 0.3); */
  background-size: 50% 4px !important;
}
.title {
  background-image: linear-gradient(#fff, #fff);
  background-position: center bottom;
  background-repeat: no-repeat;
  transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  text-decoration: none;
  height: 72px;
  background-size: 0 4px;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: center;
}
.sort:last-child {
  width: 130px;
}
.sort:nth-child(3) {
  width: 120px;
}
.title:hover {
  cursor: pointer;
}
.hoverShow {
  cursor: pointer;
//   width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hoverShow div {
  text-align: center;
  width: 100%;
  height: 46px;
  line-height: 46px;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
}
// .hoverShow div:hover {
//   background: rgba(0, 0, 0, 0.6);
// }
.NarBarUlColor1 {
  .title {
    color: #fff;
    background-image: linear-gradient(#fff, #fff);
  }
  .hoverShow div {
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    &:hover {
      background: rgba(0, 0, 0, 0.6);
      //   opacity: .8;
    }
  }
}
.NarBarUlColor2 {
  .title {
    color: #000;
    background-image: linear-gradient(#0052d9, #0052d9);
  }
  .hoverShow div {
    color: #000;
    background: rgba(255, 255, 255, 1);
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>

